import { render, staticRenderFns } from "./ocpcInfoTable.vue?vue&type=template&id=7d2a2ca1&scoped=true"
import script from "./ocpcInfoTable.vue?vue&type=script&lang=js"
export * from "./ocpcInfoTable.vue?vue&type=script&lang=js"
import style0 from "./ocpcInfoTable.vue?vue&type=style&index=0&id=7d2a2ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a2ca1",
  null
  
)

export default component.exports